import { createSelector } from 'reselect';

import { getTrustedFunnel } from '../state';

export const userHasConductedSearch = createSelector(
  [getTrustedFunnel],
  ({ searchEventGuid }) => !!searchEventGuid,
);

export const getCurrentScreenName = createSelector(
  [getTrustedFunnel],
  ({ currentScreenName }) => currentScreenName,
);

export const getViewGuid = createSelector([getTrustedFunnel], ({ viewGuid }) => viewGuid);

export const getSearchEventGuid = createSelector(
  [getTrustedFunnel],
  ({ searchEventGuid }) => searchEventGuid,
);

export const getSearchResultsPageGuid = createSelector(
  [getTrustedFunnel],
  ({ searchResultsPageGuid }) => searchResultsPageGuid,
);

export const getSearchResultsOptionGuid = createSelector(
  [getTrustedFunnel],
  ({ searchResultsOptionGuid }) => searchResultsOptionGuid,
);

export const getSearchResultSelectedGuid = createSelector(
  [getTrustedFunnel],
  ({ searchResultSelectedGuid }) => searchResultSelectedGuid,
);
